import React, { useEffect, useState, useMemo } from "react";
import BasicTable from "../../maincomponent/reacttable/table";
import { appoinment } from "../../../text/apidata";
import axios from "axios";
import "../../style/page/tabs/appoinments.scss";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import noimage from "../../../assets/images/noimage.png";
import pdf from "../../../assets/images/pdf.png"
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";

function Appoinment(props) {
  const doctor = useNavigate();
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [tableheaderdata2, settableheaderdata2] = useState([]);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [datacount, setdatacount] = useState();
  const [range, setrange] = useState([]);
  const [datasplit, setdatasplit] = useState(1);
  const editdoctorid = useSelector((state) => state.counter.edituserdoctorid);

  useEffect(() => {
    console.log(props.editdoctorid);
    props.loaderchange("true");
    axios({
      method: "get",
      url: appoinment,
      params: {
        doctor: editdoctorid,
        page: dtpageindex,
        page_size: dtpagesize,
        visit_date__gte: range == [] ? "" : range[0],
        visit_date__lte: range == [] ? "" : range[1],
        type: datasplit == 1 ? 0 : 1,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
    })
      .then((res) => {
        setdatacount(
          datasplit == 1 ? res.data.data_count : res.data.data_count
        );
        // var online = [];
        // var hosvis = [];
        // res.data.data.forEach((element) => {
        //   if (element.type == "0") {
        //     //     setonlinedata((prev)=>[...prev,element])
        //     online.push(element);
        //   } else {
        //     hosvis.push(element);
        //   }
        // });
        // const numAscending = [...res.data.data].sort((a, b) => a.day - b.day);
        if (datasplit == 1) {
          settableheaderdata(res.data.data);
        } else {
          settableheaderdata2(res.data.data);
        }
        props.loaderchange("false");
      })
      .catch((error) => {
        console.log(error);
        props.loaderchange("false");
        // setdtPageindex(dtpageindex-1)
        props.popupalert("true");
        props.popuptext("No Data Available");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      });
  }, [dtpageindex, dtpagesize, editdoctorid, range, datasplit]);

  const columns = useMemo(
    () => [
      {
        Header: "Created date",
        accessor: "",

        Cell: (row) => {
          const dateString = row.row.original.created_date;
          const dateObject = new Date(dateString);

          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12; // 0 should be converted to 12

          const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={`${formattedTime}`}
              >
                {`${row.row.original.created_date.slice(0, 10) +
                  "  " +
                  formattedTime
                  }`}
              </p>
            </>
          );
        },
      },
      {
        Header: "ID",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.id.slice(-12)}
              >
                {String(row.row.original.id).slice(-12)}
              </p>
              <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  let isCopy = copy(String(row.row.original.id).slice(-12));
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button>
            </>
          );
        },
      },
      {
        Header: "Doctor Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(
                    row.row.original.doctor.first_name
                  )}
                >
                  {String(row.row.original.doctor.first_name)}
                </div>
              </span>
            </>
          );
        },
      },

      {
        Header: "Patient Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(
                    "Ph.No:" + row.row.original.patient.phonenumber
                  )}
                >
                  {String(
                    row.row.original.patient.first_name +
                    row.row.original.patient.last_name
                  )}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Patient Ph.No",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(
                    row.row.original.patient.phonenumber
                  )}
                >
                  {String(row.row.original.patient.phonenumber)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "UHID",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(row.row.original.patient.p_uhid)}
                >
                  {String(row.row.original.patient.p_uhid)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Status",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(row.row.original.status)}
                >
                  {row.row.original.status == "0" ? (
                    <p style={{ color: "blue", fontWeight: 700 }}>Pending</p>
                  ) : row.row.original.status == "1" ? (
                    <p style={{ color: "red", fontWeight: 700 }}>Canceled</p>
                  ) : (
                    <p style={{ color: "green", fontWeight: 700 }}>Completed</p>
                  )}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Razor pay ID",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(
                    row.row.original.appointmentbookrazorpay
                      .appointment_order_id
                  )}
                >
                  {row.row.original.appointmentbookrazorpay
                    .appointment_order_id == null
                    ? "--"
                    : row.row.original.appointmentbookrazorpay
                      .appointment_order_id}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Paid",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(
                    row.row.original.appointmentbookrazorpay.isPaid
                  )}
                >
                  {row.row.original.appointmentbookrazorpay.isPaid == false ? (
                    <p style={{ color: "red", fontWeight: 700 }}>No</p>
                  ) : (
                    <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                  )}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "VisitDate",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(row.row.original.visit_date)}
                >
                  {String(row.row.original.visit_date)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "VisitTime",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={String(row.row.original.visit_slot)}
                >
                  {String(row.row.original.visit_slot)}
                </div>
              </span>
            </>
          );
        },
      },

      {
        Header: "Final Report",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <img
                  style={{
                    height: "2.5rem",
                    width: "2.5rem",
                    // borderRadius: "50%",
                  }}
                  onClick={(e) => {
                    {
                      row.row.original.prescription_pdf_file_media != null &&
                        window.open(
                          row.row.original.prescription_pdf_file_media != null
                            ? row.row.original.prescription_pdf_file_media
                              .file_url
                            : ""
                        );
                    }
                  }}
                  className="pointer"
                  src={
                    row.row.original.prescription_pdf_file_media != null
                      ? /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(
                        String(
                          row.row.original.prescription_pdf_file_media
                            .file_url
                        )
                      )
                        ? row.row.original.prescription_pdf_file_media.file_url
                        : pdf
                      : noimage
                  }
                ></img>
              </span>
            </>
          );
        },
      },
      {
        Header: "Visit Type",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={
                    String(row.row.original.type) == 0
                      ? "Online"
                      : "Hospital Visit"
                  }
                >
                  {String(row.row.original.type) == 0
                    ? "Online"
                    : "Hospital Visit"}
                </div>
              </span>
            </>
          );
        },
      },
    ],
    []
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  const handlechangedate = (name, value) => {
    // let data =value.slice(0, 10)
    if (value != null) {
      setrange([]);
      setTimeout(() => {
        setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
        setTimeout(() => {
          console.log(value.slice(0, 10));
        }, 1000);
      }, 400);
    }
    // setcurrentdate(value.slice(0, 10));
    // let result = value.replaceAll('/','-');

    // console.log(currentdate)
  };
  const cleaningrange = () => {
    setrange([]);
  };

  const datachange = (e) => {
    if (datasplit == 0) {
      setdatasplit(1);
    } else {
      setdatasplit(0);
    }
  };
  return (
    <>
      <div className="maincontainer_appoinment">
        <nav>
          <div
            class="nav nav-tabs"
            id="nav-tab"
            role="tablist"
            style={{
              backgroundColor: "white",
              // boxShadow:
              //   "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
              height: "50px",
              // borderRadius:"10px"
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <button
              class="nav-link active online"
              id="nav-home-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-home"
              type="button"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
              onClick={(e) => datachange(e)}
            >
              Online
            </button>
            <button
              class="nav-link hospitalvisit"
              id="nav-home-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-home"
              type="button"
              role="tab"
              aria-controls="nav-home"
              aria-selected="false"
              onClick={(e) => datachange(e)}
            >
              Hospital Visit
            </button>
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
          <div
            class="tab-pane fade show active"
            id="nav-home"
            role="tabpanel"
            aria-labelledby="nav-home-tab"
          >
            {/* <div className="datepicker"> */}
            <DateRangePicker
              getPopupContainer={trigger => trigger.parentElement}
              placement="auto"
              editable={false}
              appearance="default"
              size="lg"
              placeholder="From - To"
              style={{ width: 270, padding: 10 }}
              onClean={(e) => cleaningrange(e)}
              onChange={(e) => {
                if (e != null) {
                  e.forEach((newValue) => {
                    var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                    var localISOTime = new Date(newValue - tzoffset)
                      .toISOString()
                      .slice(0, -1);
                    handlechangedate("validtill", localISOTime);
                  });
                }
              }}
            />
            {/* </div> */}
            <div className="appoinment">
              <div className="table-content-appoinment">
                <div className="table-appoinment">
                  {datasplit == 1 ? (
                    <BasicTable
                      columns={columns}
                      data={tableheaderdata}
                      pagesize={pagesize}
                      pageindex={pageindex}
                      dtpagesize={dtpagesize}
                      dtpageindex={dtpageindex}
                      datacount={datacount}
                    />
                  ) : (
                    <BasicTable
                      columns={columns}
                      data={tableheaderdata2}
                      pagesize={pagesize}
                      pageindex={pageindex}
                      dtpagesize={dtpagesize}
                      dtpageindex={dtpageindex}
                      datacount={datacount}
                    />
                  )}
                </div>
              </div>
            </div>
            <ReactTooltip
              id="appoinment"
              arrowColor="transparent"
              place="bottom-start"
              delayShow={200}
              style={{
                backgroundColor: "#707070",
                fontSize: "10px",
                textAlign: "center",
                padding: "5px",
                fontWeight: 400,
              }}
            />
          </div>
          <div
            class="tab-pane fade"
            id="nav-profile"
            role="tabpanel"
            aria-labelledby="nav-profile-tab"
          >
            ...
          </div>
        </div>
      </div>
    </>
  );
}

export default Appoinment;
